import { isAxiosError } from "axios";

const maxProblemDetailsSize = 1024 * 1024;

export async function normalizeProblemDetailsErrorResponse(error: unknown): Promise<void> {
	if(!isAxiosError(error)
		|| !error.response
		|| typeof Blob === "undefined"
		|| !(error.response.data instanceof Blob)
		|| error.response.data.size > maxProblemDetailsSize
	) {
		return;
	}

	try {
		const data = JSON.parse(await error.response.data.text());
		if(data && typeof data === "object") {
			error.response.data = data;
		}
	} catch {
		// Ответ не является Problem Details в JSON — оставляем исходное тело без изменений.
	}
}

export function getProblemDetailsText(data: unknown): { title: string; detail: string } {
	let problemDetails = data;

	if(typeof data === "string") {
		try {
			problemDetails = JSON.parse(data);
		} catch {
			return { title: "", detail: "" };
		}
	}

	if(!problemDetails || typeof problemDetails !== "object") {
		return { title: "", detail: "" };
	}

	const { title, detail } = problemDetails as { title?: unknown; detail?: unknown };

	return {
		title: typeof title === "string" ? title.trim() : "",
		detail: typeof detail === "string" ? detail.trim() : ""
	};
}
